import { __rest, __assign } from 'tslib';
import React from 'react';
import { useIsDesktop } from '../../mq/esm';
import { InternationalPhoneInputDesktop } from './desktop/Component.desktop.js';
import { InternationalPhoneInputMobile } from './mobile/Component.mobile.js';
import '../../input/esm/desktop';
import '../../input-autocomplete/esm/desktop';
import '../../select/esm/desktop';
import './components/base-international-phone-input/Component.js';
import 'react-merge-refs';
import '@maskito/core';
import '@maskito/react';
import '../../select/esm/shared';
import '../../shared/esm';
import './utils/index.js';
import './consts.js';
import './data/country-data.js';
import './components/country-select/Component.js';
import '@alfalab/icons-glyph/WorldMagnifierMIcon';
import './components/flag-icon/component.js';
import 'classnames';
import './components/flag-icon/flagSprite.js';
import './components/select-field/component.js';
import '@alfalab/hooks';
import '../../input/esm/mobile';
import '../../input-autocomplete/esm/mobile';
import '../../select/esm/mobile';

var InternationalPhoneInput = React.forwardRef(function (_a, ref) {
    var breakpoint = _a.breakpoint, client = _a.client, _b = _a.defaultMatchMediaValue, defaultMatchMediaValue = _b === void 0 ? client === undefined ? undefined : client === 'desktop' : _b, restProps = __rest(_a, ["breakpoint", "client", "defaultMatchMediaValue"]);
    var isDesktop = useIsDesktop(breakpoint, defaultMatchMediaValue);
    return isDesktop ? (React.createElement(InternationalPhoneInputDesktop, __assign({}, restProps, { ref: ref }))) : (React.createElement(InternationalPhoneInputMobile, __assign({}, restProps, { ref: ref })));
});
InternationalPhoneInput.displayName = 'InternationalPhoneInput';

export { InternationalPhoneInput };
